import { MSALInfo } from '../types';
import getAccessToken from './getAccessToken';

const createAuthenticatedFetch = (
    clientId: string,
    msalInfo: MSALInfo,
    requiresAuthentication: boolean
) => {
    return async (
        url: string,
        options: RequestInit = {}
    ): Promise<Response> => {
        const headers = new Headers(options.headers);
        const accessToken = await getAccessToken(
            clientId,
            msalInfo,
            requiresAuthentication
        );

        if (accessToken && accessToken !== '') {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }

        const request = fetch(url, {
            ...options,
            headers,
            credentials: 'include'
        });
        request.then((response) => {
            if (response.status === 403) {
                // Die
                msalInfo.instance.logout();
            }
        });
        return request;
    };
};

export default createAuthenticatedFetch;
